import React, { useState, useCallback, useEffect, useRef } from 'react';
import { getVisibleSelectionRect } from 'draft-js';
import './AddLinkInputTooltip.scss';
import { func, shape } from 'prop-types';

function AddLinkInputTooltip({ editorRef, onLinkAdd }) {
  const [url, setUrl] = useState('');
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const tooltipContainer = useRef(null);
  const tooltipInput = useRef(null);

  const handleInputChange = useCallback(event => setUrl(event.target.value));
  const handleContainerClick = useCallback(event => event.stopPropagation());

  const handleKeyPress = useCallback(event => {
    if (event.key === 'Enter') onLinkAdd(url);
  });

  const handleBlur = useCallback(() => onLinkAdd(url));

  useEffect(() => {
    const { editorContainer } = editorRef.current.editor;
    const editorContainerRect = editorContainer.getBoundingClientRect();
    const selectionRect = getVisibleSelectionRect(window);

    const top =
      editorContainer.offsetTop - tooltipContainer.current.offsetHeight + (selectionRect.top - editorContainerRect.top);
    const left = editorContainer.offsetLeft + (selectionRect.left - editorContainerRect.left) + selectionRect.width / 2;
    setPosition({ top, left });
    tooltipInput.current.focus();
  }, [editorRef]);

  return (
    <div
      ref={tooltipContainer}
      className="add-link-input-tooltip input-group position-absolute"
      style={{ ...position }}
    >
      <input
        ref={tooltipInput}
        className="form-control"
        placeholder="Type URL link"
        type="text"
        value={url}
        onBlur={handleBlur}
        onChange={handleInputChange}
        onClick={handleContainerClick}
        onKeyPress={handleKeyPress}
      />
    </div>
  );
}

AddLinkInputTooltip.propTypes = {
  onLinkAdd: func.isRequired,
  editorRef: shape({}).isRequired,
};

export default AddLinkInputTooltip;
